import React from "react";
// import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { translate } from "../../utils/useful";
// import FormViewer from "../FormViewer";
// import SwitchInput from "../inputs/SwitchInput";
// import TopicView from "../views/messenger/sideBar/TopicView";
// import StagesManager from "../StagesManager";
// import Dropzone from 'react-dropzone'
import CustomDropZone from "../CustomDropZone";
import HttpServices from "../../utils/Http.services";
import { nanoid } from "nanoid";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { read, utils } from "xlsx";


class ImportModalFirst extends React.Component {
    state = {
        // Storages: [
        //     { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "My Device" },
        //     { icon: "/assets/icons/uploadmodal/link.svg", title: "Link (URL)" },
        //     { icon: "/assets/icons/uploadmodal/googledrive.svg", title: "Google Drive" },
        //     { icon: "/assets/icons/uploadmodal/onedrive.svg", title: "One Drive" },
        //     { icon: "/assets/icons/uploadmodal/dropbox.svg", title: "DropBox" },
        // ],

        options: [

        ]
    }

    handleInputChange(files) {
        let tempId = nanoid()
        // let paths = this.props.paths
        let uploadList = this.state.uploadingList ?? []
        uploadList = [files]
        this.setState({ uploadList, tempId });
        // console.log(uploadList)
        // console.log(this.props.applet)


        // console.log(files)
        files.forEach(file => {
            // HttpServices.addUploadQueque(file, { folder: this.props.applet?._id, type: 'upload', drive: '123', applet: this.props.applet }, tempId, (fetchResult, fetchError) => {
            //     this.props.changeStage("second")
            // })
            this.analyseExcel(file, () => {

                this.props.changeImportInfo('file', file, () => {
                    this.props.changeStage("mapData")
                })

            })

        });
    }


    render() {
        // let options = this.state.options
        // const dropzoneRef = React.createRef();
        // onClick={() => this.props.changeStage("second")}
        // console.log("this.props.queque?.uploads")

        let currentUpload = []
        if (this.state.tempId && this.props.queque?.uploads) {
            currentUpload = this.props.queque?.uploads.filter(file => file.tempId == this.state.tempId)
        }

        // let temp = [{ file: { name: 'test file' }, precentage: 50 }]

        return (

            <div className="w-100 h-100 br-10 p-2" style={{ backgroundColor: "white", }} >

                {currentUpload.length == 0 && (
                    <CustomDropZone disabled={false} information={{ accept: '.csv, application/vnd.ms-excel, text/csv' }} onDrop={(e) => this.handleInputChange(e, false)}>
                        <div className="h-100 br-5  flexcc flex-column " style={{ border: "1px dashed #4185FA" }}>
                            <img width={80} src="/assets/icons/applets/database/import-purple-big.svg" />
                            <p>{translate('Browse files to upload')}</p>
                            <p className="font-size-14">{translate('or drag a file in here')}.</p>
                            <p className="font-size-12 mt-1" style={{ color: "#777" }}>{translate('Valid formats are csv, xls')}.</p>

                        </div>
                    </CustomDropZone>
                )}


                {currentUpload.length > 0 && (
                    <div className="px-4 flexcc flex-column h-100">
                        <div className="px-3 w-100 mb-3">
                            <p className="text-semibold">{translate("Uploading ...")}</p>
                        </div>
                        <div className="shadow-2 br-8 w-100 py-2">
                            {this.props.queque?.uploads?.map((item, index) => {

                                {/* {temp?.map((item, index) => { */ }
                                return (
                                    <div>
                                        <div className="uploaded-files-list p-3 scroll-no-scrollbar" style={{ display: "flex", flexDirection: "column", overflowY: "scroll" }}>
                                            <div>
                                                <span className="choosed-file">
                                                    <div className="flexcb w-100">
                                                        <div className="pb-2 font-size-14"> {item?.file?.name}</div>
                                                        <div className="value">
                                                            <div style={{ color: "black", fontSize: "11px" }}>
                                                                <span >{item.precentage ? item.precentage.toFixed(0) : 0}%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className=' flexc br-10' style={{ background: 'rgba(239, 239, 239,0.5)', height: '10px' }}>
                                                        <div className=" br-10" style={{ background: 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))', width: item.precentage + '%', height: '10px' }}>
                                                        </div>
                                                    </div>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                )}

            </div>



        );

    }




    analyseExcel = (file, cb) => {

        console.log("analyseExcel")
        console.log(file)

        if (file) {
            console.log(file)
            const reader = new FileReader();
            reader.onload = async (e) => {
                // console.log(e)
                const bstr = e.target.result

                // let result = excelToJson({
                //     sourceFile: fileee//fs.readFileSync(fileee)
                // });
                // console.log(result)
                // alert(text)

                const wb = read(bstr, { type: "binary" });
                // const wb = read(file);
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                let headersNames = this.get_header_row(ws)
                let fields = {}

                let headers = []

                if (Array.isArray(headersNames)) {
                    headersNames.forEach((header, index) => {
                        headers.push({ title: header, value: index })

                    

                        this.props.headers.forEach(element => {

                            // if(header == 'Row ID'){

                            //     console.log(element)
                            //     console.log(header)
    
                                
                            // }

                            if (element.key.toLowerCase() == header.trim().toLowerCase() || element.information.label.trim().toLowerCase() == header.trim().toLowerCase()) {
                                fields[element.key] = index
                            }
                        })

                    })
                }

                // console.log(fields)

                this.props.changeImportInfo('rawHeaders', headers, () => {
                    this.props.changeImportInfo('fields', fields, () => {

                        cb()
                    })

                })


                // const result = utils.sheet_to_json(ws, { header: headers, defval: '', blankrows: true, skipHeader: false });
                // console.log(result)
                // console.log(headers)
                // this.insertJsonToTable(result)


            };
            reader.readAsBinaryString(file)



            // let wb = XLSX.read(file)
            // const wb = XLSX.read(file);
            // console.log(wb)
            // const wsname = wb.SheetNames[0];
            // console.log(wsname)
            // const ws = wb.Sheets[wsname];
            // console.log(ws)
            // const result = XLSX.utils.sheet_to_json(ws, {header:["code","name","family"]});
            // console.log(result)

        }

    }



    get_header_row(sheet) {
        var headers = [];
        var range = utils.decode_range(sheet['!ref']);
        var C, R = range.s.r; /* start in the first row */
        /* walk every column in the range */
        for (C = range.s.c; C <= range.e.c; ++C) {
            var cell = sheet[utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */

            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if (cell && cell.t) hdr = utils.format_cell(cell);

            headers.push(hdr);
        }
        return headers;
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportModalFirst);